(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditEmailController', EditEmailController);

    EditEmailController.$inject = ['$modalInstance', 'email', 'authentication'];

    function EditEmailController($modalInstance, email, authentication) {
        var vm = this;

        vm.email = email;

        vm.onSubmit = onSubmit;

        function onSubmit() {
            authentication.changeLoginEmail({
                identifier: vm.email,
                email: vm.newEmail
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
            });
        }
    }
})();